import React from "react";

import styles from "./style.module.scss";
import { CompanyInfo } from "../../models/company";
import CompanyLogo from "../CompanyLogo";

interface TopCompanyInfoProps {
  companyInfo: CompanyInfo;
}

const TopCompanyInfo: React.FC<TopCompanyInfoProps> = (
  props: TopCompanyInfoProps
) => {
  const { companyInfo } = props;

  return (
    <div className={styles.companyInfo}>
      <CompanyLogo
        className={styles.companyLogo}
        logoUrl={companyInfo.logoUrl ?? null}
        companyName={companyInfo.name ?? ""}
      />
      <div className={styles.companyName}>{companyInfo.name}</div>
    </div>
  );
};

export default TopCompanyInfo;
